import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  createShippingProfile({ commit }, item) {
    return this.$axios.$post('admin/shippingProfiles/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
    })
  },
  removeShippingProfile({ commit }, item) {
    return this.$axios.$delete(`admin/shippingProfiles/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateShippingProfile({ commit }, item) {
    return this.$axios.$put(`admin/shippingProfiles/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
    })
  },
  fetchShippingProfile({ commit }, id) {
    return this.$axios.$get(`admin/shippingProfiles/${id}`).then((response) => {
      return response.data
    })
  },
  fetchShippingProfiles({ commit }) {
    return this.$axios.$get('admin/shippingProfiles').then((response) => {
      commit('load', response.data)
    })
  },

  /**
   * Fetch excluded products for a shipping profile
   * @param {Object} context - Vuex context
   * @param {number} shippingProfileId - Shipping profile ID
   * @returns {Promise<Array>} Excluded products list
   */
  fetchExcludedProducts(_, shippingProfileId) {
    return this.$axios.$get(`admin/shippingProfiles/${shippingProfileId}/excluded-products`).then((response) => {
      return response.data || []
    })
  },

  /**
   * Add a product to the exclusion list
   * @param {Object} context - Vuex context
   * @param {Object} payload - Contains shippingProfileId, productId, and optional reason
   * @returns {Promise<Object>} Created exclusion
   */
  addExcludedProduct(_, { shippingProfileId, productId, reason }) {
    return this.$axios.$post(`admin/shippingProfiles/${shippingProfileId}/excluded-products`, {
      product_id: productId,
      reason,
    })
  },

  /**
   * Remove a product from the exclusion list
   * @param {Object} context - Vuex context
   * @param {Object} payload - Contains shippingProfileId and productId
   * @returns {Promise<Object>} API response
   */
  removeExcludedProduct(_, { shippingProfileId, productId }) {
    return this.$axios.$delete(`admin/shippingProfiles/${shippingProfileId}/excluded-products/${productId}`)
  },
}
